module.exports = "https://drv7djjgp3j3.cloudfront.net/f14feaec-818c-4d31-af5e-fd46c35896d3/images/logo_123travel_white.png?be400652c6578f1bdbb76928ccf3a821";